import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/reportPayroll-actions';
import { ReportPayrollActions } from '../constants';
import { IReportPayroll } from 'src/types/reportPayroll';

export interface ReportPayrollState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IReportPayroll>;
    current: IReportPayroll | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function reportPayrolls(state: ReportPayrollState = initialState, action: Actions | any): ReportPayrollState {
    switch (action.type) {
        case requestType(ReportPayrollActions.PERSIST_REPORT_PAYROLL):
            return { ...state, error: '', inProgress: true };
        case successType(ReportPayrollActions.PERSIST_REPORT_PAYROLL):
            return { ...state, inProgress: false };
        case failureType(ReportPayrollActions.PERSIST_REPORT_PAYROLL):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ReportPayrollActions.FETCH_REPORT_PAYROLLS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ReportPayrollActions.FETCH_REPORT_PAYROLLS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ReportPayrollActions.FETCH_REPORT_PAYROLLS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(ReportPayrollActions.FETCH_REPORT_PAYROLL):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ReportPayrollActions.FETCH_REPORT_PAYROLL):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ReportPayrollActions.FETCH_REPORT_PAYROLL):
            return { ...state, inProgress: false, error: action.error };
        case requestType(ReportPayrollActions.DELETE_REPORT_PAYROLL):
            return { ...state, error: '', inProgress: true };
        case successType(ReportPayrollActions.DELETE_REPORT_PAYROLL):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IReportPayroll) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(ReportPayrollActions.DELETE_REPORT_PAYROLL):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
